import styled from 'styled-components';

export const PieChartContainer = styled.div`
  padding: 20px 24px 16px;
  height: 100%;
  border-radius: 6px;
  border: 1px solid #f4f4f4;
  background: white;
`;
